/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Progress_StartingInputs */

const en_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`starting...`)
};

const fr_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`demarrage...`)
};

const de_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beginnend...`)
};

const it_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di partenza...`)
};

const ru_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`начало...`)
};

const es_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a partir de...`)
};

const zh_cn2_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始...`)
};

const ja_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起動...`)
};

const hi_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू हो रहा है...`)
};

const pt_pt2_new_project_media_progress_starting = /** @type {(inputs: New_Project_Media_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`começando...`)
};

/**
* | output |
* | --- |
* | "starting..." |
*
* @param {New_Project_Media_Progress_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_progress_starting = /** @type {((inputs?: New_Project_Media_Progress_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Progress_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_progress_starting(inputs)
	if (locale === "de") return de_new_project_media_progress_starting(inputs)
	if (locale === "it") return it_new_project_media_progress_starting(inputs)
	if (locale === "ru") return ru_new_project_media_progress_starting(inputs)
	if (locale === "es") return es_new_project_media_progress_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_progress_starting(inputs)
	if (locale === "ja") return ja_new_project_media_progress_starting(inputs)
	if (locale === "hi") return hi_new_project_media_progress_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_progress_starting(inputs)
	return en_new_project_media_progress_starting(inputs)
});